<script lang="ts" setup>
import { linkifyUrl } from '@/libs/utilities/linkifyUrl'
import { computed } from 'vue'
import escapeHtml from 'escape-html'

const props = defineProps<{
  text: string
}>()

const htmlifiedText = computed(() => {
  return linkifyUrl(escapeHtml(props.text))
})
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <p :class="$style.text" v-html="htmlifiedText" />
</template>

<style lang="scss" module>
.text {
  word-break: break-all;
  white-space: pre-wrap;
}

.text :deep(a) {
  color: $color-text-and-object-accent-primary;
}
</style>
